export default __webpack_public_path__ + "assets/Compare2.png";